import { Component, OnInit } from '@angular/core';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { FormGroup } from '@angular/forms';
import { AuthenticationResult } from '../models/authentication.model';

@Component({
  selector: 'app-auth-user-activation',
  templateUrl: './auth-user-activation.component.html',
  styleUrls: ['./auth-user-activation.component.css']
})
export class AuthUserActivationComponent extends AuthBaseComponent implements OnInit {

  public data: any;

  public statements = {
    acceptActivation: true,
    acceptSavingsMailing: true,
    acceptHealthMailing: true,
    acceptDecleration: false
  }
  ngOnInit() {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2139' })
      .subscribe(res => console.log("sent elasticLog code:2139 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    sessionStorage.setItem("currentWindow", "עדכון רישום אקטיבציה");
    sessionStorage.setItem("elasticCode", "2193");
    this.data = this.modalService.data
    this.statements.acceptActivation = this.data ? this.data.showActivation : true;
    this.statements.acceptSavingsMailing = this.data ? this.data.showSavingsMailing : true;
    this.statements.acceptHealthMailing = this.data ? this.data.showHealthMailing : true;
  }
  submit(form: FormGroup): void {

    const controls = this.inputsQuery.map(elm => elm);
    let element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    const checkbox = document.querySelector('input[type=checkbox]') as any;

    if (element && controls.length > 1) {
      if (controls[0].ngControl.errors.pattern) {
        element = controls[0].elementRef.nativeElement;
      } else if (controls[0].ngControl.errors.required == null) {
        element = controls[1].elementRef.nativeElement;
      }
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    } else if (!element && checkbox.classList.contains('ng-invalid')) {
      checkbox.setAttribute('aria-invalid', true);
      setTimeout(() => checkbox.focus(), 0);
    }

    if (form.valid) {
      this.pending = true;
      this.serverError = null;
      //console.log("sent parametes", this.statements);
      this.authUserService.sendAuthData("UpdateActivation", { ...this.statements, email: form.value.email })
        .subscribe((res: AuthenticationResult) => {
          this.modalService.close(res.Details);
        }, () => this.pending = false,
          () => this.pending = false
        )
    }
    this.buildFormAccessibility();
  }

}
